import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import updateToken from '@/middlewares/updateToken-middleware';

const tutorialRepository = RepositoryFactory.get('tutorial');

const state = () => ({
  dataAtual: null,
  breadcrumbItems: [],
  snackbar: {
    visibilidade: false,
    cor: 'success',
    texto: '',
  },
  tutorial: {
    nome: '',
    visibilidade: false,
  },
  loading: false,
  aviso: {
    visibilidade: false,
    descricao: '',
    acoes: [],
  },
  loginExpirado: false,
  fimSessao: '',
  usuarioNaoCadastrado: false,
  erros: [
    { codigo: 401, descricao: 'Acesso não autorizado' },
    { codigo: 403, descricao: 'Acesso não permitido' },
    { codigo: 404, descricao: 'Serviço não encontrado' },
    { codigo: 405, descricao: 'Método de acesso não permitido' },
    { codigo: 408, descricao: 'Tempo máximo de pedido atingido' },
    { codigo: 409, descricao: 'Conflito durante a requisição' },
    { codigo: 415, descricao: 'Formato de mídia não suportado' },
    { codigo: 500, descricao: 'Problema inesperado no servidor da aplicação' },
    { codigo: 502, descricao: 'Problema no processamento da resposta' },
    { codigo: 503, descricao: 'Serviço indisponível no momento' },
    { codigo: 504, descricao: 'Tempo máximo de resposta atingido' },
    { codigo: 505, descricao: 'Versão do protocolo de acesso incompatível' },
  ],
});

const getters = {

};

const actions = {
  setDataAtual({ commit }, dataAtual) {
    commit('SET_DATA_ATUAL', dataAtual);
  },
  success({ commit }, data) {
    if (data.response.status === 200 || data.response.status === 201
      || data.response.status === 204) {
      commit('SET_SNACKBAR', {
        cor: 'success',
        texto: data.message ? data.message : 'Operação realizada com sucesso',
      });
    } else {
      commit('SET_SNACKBAR', {
        cor: 'error',
        texto: 'Erro durante a operação',
      });
    }
  },
  error({ st, commit }, data) {
    let mensagem = 'Erro! ';
    if (data.message) {
      mensagem = data.message;
    } else if (data.response) {
      if (data.response.data.message) {
        mensagem += data.response.data.message;
      } else if (data.response.statusText) {
        mensagem += data.response.statusText;
      } else {
        const erro = st.erros.find((e) => e.codigo === data.response.status);
        if (erro) {
          mensagem += `${erro.codigo} ${erro.descricao}`;
        } else {
          mensagem += `${data.response.status} Problema não identificado ao requisitar o serviço`;
        }
      }
    } else {
      mensagem += 'Não foi possível conectar...';
    }
    commit('SET_SNACKBAR', { cor: 'error', texto: mensagem });
  },
  showMessage({ commit }, mensagem) {
    commit('SET_SNACKBAR', { cor: mensagem.cor, texto: mensagem.texto });
  },
  setBreadcrumbs({ commit }, breadcrumbs) {
    commit('SET_BREADCRUMBS', breadcrumbs);
  },
  showTutorial({ commit, rootState }, { nome, nomeGenerico = nome }) {
    // Atualiza o token
    updateToken();

    const tutorial = {
      nome,
      visibilidade: true,
    };
    const tutorialProp = nomeGenerico[0].toLowerCase() + nomeGenerico.substring(1);
    const dadosTutorial = rootState.tutorial.dados;
    let isTutorialExibido = true;

    commit('SET_TUTORIAL', tutorial);

    if (!dadosTutorial[tutorialProp]) {
      dadosTutorial[tutorialProp] = true;
      isTutorialExibido = false;
    }

    if (!isTutorialExibido) {
      tutorialRepository.update(dadosTutorial).then((res) => {
        commit('tutorial/SET_DADOS', res.data, { root: true });
      });
    }
  },
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading);
  },
  setAviso({ commit }, aviso) {
    commit('SET_AVISO', aviso);
  },
  setLoginExpirado({ commit }, status) {
    commit('SET_LOGIN_EXPIRADO', status);
  },
  setFimSessao({ commit }, fimSessao) {
    commit('SET_FIM_SESSAO', fimSessao);
  },
  setUsuarioNaoCadastrado({ commit }, status) {
    commit('SET_USUARIO_NAO_CADASTRADO', status);
  },
};

const mutations = {
  SET_DATA_ATUAL(st, dataAtual) {
    st.dataAtual = dataAtual;
  },
  SET_BREADCRUMBS(st, breadcrumb) {
    st.breadcrumbItems = breadcrumb;
  },
  SET_SNACKBAR(st, snackbar) {
    snackbar.visibilidade = !st.snackbar.visibilidade;
    st.snackbar = snackbar;
  },
  SET_TUTORIAL(st, tutorial) {
    st.tutorial = tutorial;
  },
  SET_LOADING(st, loading) {
    st.loading = loading;
  },
  SET_AVISO(st, aviso) {
    st.aviso = aviso;
  },
  SET_LOGIN_EXPIRADO(st, status) {
    st.loginExpirado = status;
  },
  SET_FIM_SESSAO(st, fimSessao) {
    st.fimSessao = fimSessao;
  },
  SET_USUARIO_NAO_CADASTRADO(st, status) {
    st.usuarioNaoCadastrado = status;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
